import { Match } from './shared/types/Match';

export const isMatchLive = (match: Match): boolean =>
  match.state === 'valid' && ['paused', 'live', 'background'].includes(match.stateTime);
